import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function runJob(path, payload) {
  const { data } = await api.post(path, payload);
  if (!data?.job_id) return data;
  for (;;) {
    await new Promise((r) => setTimeout(r, 3000));
    let job;
    try { ({ data: job } = await api.get(`/jobs/${data.job_id}`)); } catch { continue; }
    if (job.status === "done") return job.result;
    if (job.status === "failed") throw new Error(job.error || "Generation failed");
  }
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
